import Flickity from "flickity";

const nss_review_carousel = {
    init: () => {
        const nssReviewCarouselEls = document.querySelectorAll('[nss-review-carousel]');
        const sliderOptions = {
            prevNextButtons:true,
            pageDots: true,
            wrapAround: true,
            resize: true,
            freeScroll: false,
            adaptiveHeight: true,
            imagesLoaded: true,
        };

        function initSlider(section) {
            const sliderEl = section.querySelector('[nss-review-carousel-slider]');
            let sliderFlickity = null;
            if (sliderEl) {
                sliderFlickity = new Flickity(sliderEl, sliderOptions);

                window.addEventListener('load', () => {
                    setTimeout(() => {
                        sliderFlickity.resize();
                    }, 250);
                });
            }
        }

        [...nssReviewCarouselEls].forEach(nssReviewCarouselEl => {
            initSlider(nssReviewCarouselEl);
        });
    
        /**
         * Theme Editor Events
         */
        document.addEventListener(`shopify:section:load`, e => {
            const sectionId         = e.detail.sectionId,
                  sectionEl = e.target.querySelector(`[data-section-id="${sectionId}"][nss-review-carousel]`),
                  sliderEl  = sectionEl.querySelector(`[nss-review-carousel-slider]`),
                  sliderFlickityEl        = Flickity.data(sliderEl);

            if (sectionEl) {
                sliderFlickityEl?.destroy();
                initSlider(sectionEl);
            }
        });
    }
}

export default nss_review_carousel;
